module.exports = __webpack_public_path__ + "img/流行趋势分析ico.64d5b01d.png";